import { z } from "zod"
import { GenderValues, LanguageValues } from "@/types/__generated__/union-types"

export const requiredMessage = "common.fieldErrorList.requiredField"

export const stringRequired = z.string({ error: requiredMessage }).min(1, { message: requiredMessage })

export const stringOptional = z.string().optional().nullable()

export const nonEmptyStringRequired = z.string({ error: requiredMessage }).trim().min(1, { message: requiredMessage })
export const phoneNumberIsRequired = z
  .string({ error: "common.fieldErrorList.phoneNumberIsRequired" })
  .trim()
  .min(1, { message: "common.fieldErrorList.phoneNumberIsRequired" })

export const GenderSchema = z.enum(GenderValues)
export const LanguageSchema = z.enum(LanguageValues)

export const booleanRequired = z
  .boolean({ error: requiredMessage })
  .refine((v) => v === true, { message: requiredMessage })

export const textAreaDefaultMaxLength = 1000

export const MIN_GESTATION_WEEKS = 1
export const MAX_GESTATION_WEEKS = 45

export const CASE_REFERENCE_MAX_LENGTH = 35
